var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBarGraph = function SvgBarGraph(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63028 11.8265V13.3571C4.63028 14.5051 3.68896 15.5 2.43386 15.5C1.17875 15.5 0.237427 14.5051 0.237427 13.3571V11.8265C0.237427 10.6786 1.17875 9.68367 2.43386 9.68367C3.68896 9.68367 4.63028 10.6786 4.63028 11.8265Z",
    fill: "#666C95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1214 7.23469V13.3571C10.1214 14.5051 9.18003 15.5 7.92493 15.5C6.66983 15.5 5.7285 14.5051 5.7285 13.3571V7.23469C5.7285 6.08674 6.66983 5.09184 7.92493 5.09184C9.18003 5.09184 10.1214 6.08674 10.1214 7.23469Z",
    fill: "#666C95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6124 2.64286V13.3571C15.6124 14.5051 14.6711 15.5 13.416 15.5C12.1609 15.5 11.2196 14.5816 11.2196 13.3571V2.64286C11.2196 1.4949 12.1609 0.5 13.416 0.5C14.6711 0.5 15.6124 1.4949 15.6124 2.64286Z",
    fill: "#666C95"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarGraph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bar-graph.3aa35c35.svg";
export { ForwardRef as ReactComponent };